export const SET_BREADCRUMB_TITLE = 'SET_BREADCRUMB_TITLE';

export const setBreadcrumbTitle = (path, title) => {
  return {
    type: SET_BREADCRUMB_TITLE,
    payload: { path, title },
  };
};
